/* eslint-disable no-shadow */
import { APIPOST, APIGET } from '../utils/apiHelper';
import jwtHelper, {
  getToken,
  saveToken,
  destroyToken,
} from '../utils/jwtHelper';
import { LOGIN, LOGOUT, REGISTER, UPDATE_USER } from './actions.type';
import {
  SET_AUTH,
  PURGE_AUTH,
  SET_ERROR,
  CHECK_AUTH,
  SET_USER,
} from './mutations.type';

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!getToken(),
};

const getters = {
  isAuthenticated() {
    return state.isAuthenticated;
  },
};

const actions = {
  async [LOGIN](context, credentials) {
    try {
      const response = await APIPOST('auth/login', credentials, false);
      if (response.error) {
        context.commit(SET_ERROR, response.message);
      } else {
        context.commit(SET_AUTH, response);
      }
    } catch (err) {

    }
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
    window.location.reload();
  },
  [REGISTER](context, payload) {
    return new Promise((resolve, reject) => {
      APIPOST('auth/signup', payload)
        .then(({ data }) => {
          context.commit(SET_AUTH, data.user);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.message);
          reject(response);
        });
    });
  },
  async [UPDATE_USER](context) {
    context.dispatch(CHECK_AUTH);
  },
  async [CHECK_AUTH](context) {
    try {
      const token = await getToken();
      if (token) {
        const response = await APIGET('/user/profile');
        if (response.error) {
          context.commit(SET_ERROR, response.data.errors);
        } else {
          context.commit(SET_USER, response);
        }
      } else {
        context.commit(PURGE_AUTH);
      }
    } catch (err) {
      context.commit(PURGE_AUTH);
    }
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_USER](state, payload) {
    state.isAuthenticated = true;
    state.user = payload.user;
    state.errors = {};
  },
  async [SET_AUTH](state, payload) {
    state.isAuthenticated = true;
    state.user = payload.user;
    state.errors = {};
    await saveToken(payload.jwt);
    window.location.reload();
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    destroyToken();
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
